var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("value",null,null,{mutation: _vm.mutation}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mutation),expression:"mutation"}],attrs:{"type":"number"},domProps:{"value":(_vm.mutation)},on:{"input":function($event){if($event.target.composing)return;_vm.mutation=$event.target.value}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }